<template>
    <div id="info_mobile">
        <picture>
            <source :srcset="$url + 'img/bg_acesso.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_acesso.png'" type="image/png"> 
            <img id="bg" :src="$url + 'img/bg_acesso.webp'">
        </picture>
        <picture>
            <source :srcset="$url + 'img/instrucao/raio_instrucao.webp'" type="image/webp">
            <source :srcset="$url + 'img/instrucao/raio_instrucao.png'" type="image/png"> 
            <img id="raio" :src="$url + 'img/instrucao/raio_instrucao.webp'">
        </picture>
        <transition name="fade">
            <div v-if="show" id="box">
                <h3>Como jogar</h3>
                <span><a href="#" v-on:click="exit"><img :src="$url + 'img/fechar.png'"></a></span>
                <div id="text">
                    <!-- <h4>A Missão está lançada e para atingirmos nosso objetivo contamos com sua participação.
                    <font color='#9dca26'>Colete os itens</font> no mapa, acomule pontos e nos ajude a preservar a água e combater o
                    mosquito da dengue.
                    </h4> -->

                    <h4>
                        <b>Para jogar é fácil.</b>
                    </h4>
                    <br>

                    <div id="text-1">
                        <ul>
                            <li>
                                <img :src="$url + 'img/icon_analogico.png'"><br>
                                Para se movimentar utilize o <font color='#9dca26'>joystick</font> virtual.
                            </li>
                            <li>
                                <img :src="$url + 'img/instrucao/pular_bt.png'"><br>
                                Para pular clique no <font color='#9dca26'>botão.</font>
                            </li>
                        </ul>
                    </div>


                    <hr>
                    <ul>
                        <li v-for="(o, key) in itens" v-bind:key="key">
                            <img :src="$url + 'img/itens/' + o  + '.png'">
                            <br>
                            {{ itens_name[key] }}
                        </li>
                    </ul>

                    <hr>
                    <img :src="$url + 'img/dica.png'">
                    <h4>É importante lembrar que todos os dias têm missão, então depois que começar a jogar, você terá até o final do dia para cumprir as fases antes que elas recomecem.</h4>
                </div>
               
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
        name: "InfoMobileComponent",
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters(['itens', 'itens_name'])
        },
        methods: {
            yes() {
                
                this.$parent.view_info_mobile = false;
                this.$parent.focusGame();
            },
            exit() {
                
                this.$parent.view_info_mobile = false;
                this.$parent.focusGame();
            }
        },
        mounted() {
            this.show = true;
        }
    }
</script>
<style scoped>
    #bg
    {
        bottom: 0;
        height: 872px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
    }
    #info_mobile {
        background-color: rgba(0, 0, 0, .5);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 8000;
    }
    #raio
    {
        height: 575px;
        left: calc(50% - 269px);
        position: fixed;
        top: 0;
        width: 538px;
    }
    #box
    {
        background-color: #fff;
        border-radius: 30px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        color: #777;
        display: block;
        height: auto;
        left: calc(50% - 250px);
        padding: 10px;
        position: absolute;
        text-align: center;
        top: 100px;
        width: 500px;
    }
    h3
    {
        background-color: #9dca26;
        border-bottom: solid 2px rgba(0, 0, 0, .05);
        border-radius: 15px;
        box-shadow: 0 -1px 0 rgba(255, 255, 255, .5);
        box-sizing: border-box;
        color: white;
        margin: -30px auto;
        padding: 15px;
        width: 180px;
    }
    h4
    {
        font-size: 16px;
        font-weight: normal;
    }
    span
    {
        position: absolute;
        right: -30px;
        top: -30px;
    }

    /*----- text -----*/
    #text
    {
        font-size: 20px;
        margin-top: 45px;
    }
    #text > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        font-size: 16px;
        list-style: none;
        max-width: 231px;
        padding: 10px;
        text-align: center;
        vertical-align: top;
        width: 85px;
    }
    #text > ul > li > img
    {
        width: 100%;
    }
    /*----- \text\ -----*/



    /*----- text-1 -----*/
    #text-1
    {
        box-sizing: border-box;
        font-size: 20px;
        margin-top: -40px;
        padding: 20px 60px;
    }
    #text-1 > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        font-size: 16px;
        list-style: none;
        padding: 10px 5px;
        text-align: center;
        vertical-align: top;
        width: 50%;
    }
    
    #text-1 > ul > li:nth-child(1)
    {
        border-right: solid 1px #e5e5e5;
    }
    /*----- \text-1\ -----*/

    

    .btn-01
    {
        background-color: #fff;
        border-radius: 37px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, .2);
        box-sizing: border-box;
        color: #9dca26 !important;
        display: inline-block;
        font-family: 'Paper Cutout';
        font-size: 60px;
        height: 58px;
        line-height: 34px;
        padding: 12px 15px;
        text-align: center;
        width: 90%;
    }
    .btn-01 > a
    {
        position: absolute;
    }
    .rot
    {
        transform: rotate(180deg);
    }
    .fade-enter-active, .fade-leave-active {
        top: calc(50% - 110px);
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 50%;
        opacity: 0;
    }

    @media screen and (max-width: 600px)
    {
        #text > ul > li
        {
            text-align: center !important;
            width: 100% !important;
        }
        #text-1
        {
            display: block;
            padding: 10px;
            width: 100% !important;
        }
        #text-1 > ul
        {
            display: block;
            width: 100% !important;
        }
        
    }
    @media screen and (max-width: 980px)
    {
        #box
        {
            left: 7%;
            width: 86%;
        }
    }
</style>